export default __webpack_public_path__ + "static/media/JPEG.f5bfe3c3.svg";